import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=5c5c4b3b&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style1 from "./contract.vue?vue&type=style&index=1&id=5c5c4b3b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c4b3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5c4b3b')) {
      api.createRecord('5c5c4b3b', component.options)
    } else {
      api.reload('5c5c4b3b', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=5c5c4b3b&scoped=true", function () {
      api.rerender('5c5c4b3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/house/contract.vue"
export default component.exports